import GlobalState from './GlobalState';
import GlobalStateTransform from './GlobalStateTransform';

export default function GlobalStateAccess() {
  return GlobalStateTransform(GlobalState);
}
